import React from 'react';

interface AlertProps {
  className?: string;
  children: React.ReactNode;
}

export function Alert({ className = '', children }: AlertProps) {
  return (
    <div className={`relative w-full rounded-lg border p-4 ${className}`} role="alert">
      {children}
    </div>
  );
}

interface AlertDescriptionProps {
  className?: string;
  children: React.ReactNode;
}

export function AlertDescription({ className = '', children }: AlertDescriptionProps) {
  return <div className={`text-sm [&_p]:leading-relaxed ${className}`}>{children}</div>;
}
